export default __webpack_public_path__ + "9a3038b98e535f97fae2d630d1c9a82f.svg";